import { Modal } from '@mui/material';
import { GlobalButton } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';

type ConfirmDeleteServiceModalProps = {
  open: boolean;
  serviceName?: string;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const ConfirmDeleteServiceModal = ({
  open,
  serviceName,
  isLoading = false,
  onClose,
  onConfirm,
}: ConfirmDeleteServiceModalProps) => {
  const hasName = Boolean(serviceName?.trim());

  return (
    <Modal open={open} onClose={onClose}>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
        <div className="flex flex-col p-6 gap-5 w-[420px] bg-white outline-none rounded-lg shadow-xl">
          <h2 className="text-lg font-semibold text-gray-800">
            <strong>Eliminar servicio</strong>
          </h2>
          <p className="text-base text-gray-600">
            ¿Estás seguro de <strong>eliminar</strong> {hasName ? 'el' : 'este'} servicio
            {hasName ? (
              <> "{serviceName!.trim()}"</>
            ) : (
              ''
            )}
            ? <strong>Esta acción no se puede deshacer</strong>.
          </p>
          <div className="flex gap-3 justify-end">
            <GlobalButton
              variant={GlobalButtonVariant.secondaryButton}
              action={onClose}
              disabled={isLoading}
            >
              Cancelar
            </GlobalButton>
            <GlobalButton
              variant={GlobalButtonVariant.primaryButton}
              action={onConfirm}
              disabled={isLoading}
            >
              {isLoading ? 'Eliminando...' : 'Eliminar'}
            </GlobalButton>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmDeleteServiceModal;
